/* Collection PLP — filter sidebar, hide/show, auto-submit */
(() => {
  const layout = document.querySelector('[data-collection-layout]');
  if (!layout) return;

  const STORAGE_KEY = 'ghalia-collection-filters-hidden';
  const hideBtn = layout.querySelector('[data-collection-filters-hide]');
  const showBtn = layout.querySelector('[data-collection-filters-show]');

  const setFiltersHidden = (hidden) => {
    layout.classList.toggle('is-filters-hidden', hidden);
    if (hideBtn) hideBtn.hidden = hidden;
    if (showBtn) showBtn.hidden = !hidden;
    try {
      if (hidden) sessionStorage.setItem(STORAGE_KEY, '1');
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (_) { /* noop */ }
  };

  if (window.matchMedia('(min-width: 1025px)').matches) {
    try {
      if (sessionStorage.getItem(STORAGE_KEY) === '1') setFiltersHidden(true);
    } catch (_) { /* noop */ }
  }

  hideBtn?.addEventListener('click', () => setFiltersHidden(true));
  showBtn?.addEventListener('click', () => setFiltersHidden(false));

  /* Pill tracks — scroll active pill into view (mobile / tablet) */
  const alignPillTrack = (track) => {
    if (!track || !window.matchMedia('(max-width: 1024px)').matches) return;
    const active = track.querySelector('.filter-pill.is-active');
    if (!active || track.scrollWidth <= track.clientWidth) return;
    const trackRect = track.getBoundingClientRect();
    const pillRect = active.getBoundingClientRect();
    const delta = pillRect.left - trackRect.left - (trackRect.width - pillRect.width) * 0.5;
    track.scrollLeft += delta;
  };

  document.querySelectorAll('[data-collection-pill-track]').forEach((track) => {
    requestAnimationFrame(() => alignPillTrack(track));
  });
})();

/* Collection grid — promo tiles match product-card height in each row (desktop only) */
(() => {
  const grid = document.querySelector('.collection-grid');
  if (!grid) return;
  if (window.matchMedia('(hover: none), (max-width: 1024px)').matches) return;

  const ROW_TOLERANCE_PX = 6;
  let isSyncing = false;
  let syncTimer = null;

  const syncPromoTileHeights = () => {
    if (isSyncing) return;
    const promos = grid.querySelectorAll('.collection-grid-banner--promo');
    if (!promos.length) return;

    isSyncing = true;
    try {
      const rows = [];
      [...grid.children].forEach((child) => {
        const top = child.getBoundingClientRect().top;
        let row = rows.find((entry) => Math.abs(entry.top - top) <= ROW_TOLERANCE_PX);
        if (!row) {
          row = { top, items: [] };
          rows.push(row);
        }
        row.items.push(child);
      });

      const promosToClear = new Set(promos);

      rows.forEach(({ items }) => {
        const referenceHeights = items
          .filter((el) => !el.classList.contains('collection-grid-banner--promo'))
          .map((el) => el.getBoundingClientRect().height);
        const rowHeight = Math.max(0, ...referenceHeights);
        if (!rowHeight) return;

        const target = `${Math.ceil(rowHeight)}px`;
        items
          .filter((el) => el.classList.contains('collection-grid-banner--promo'))
          .forEach((promo) => {
            promosToClear.delete(promo);
            if (promo.style.minHeight !== target) promo.style.minHeight = target;
            const media = promo.querySelector('.collection-grid-banner__media--promo');
            if (media && media.style.minHeight !== target) media.style.minHeight = target;
          });
      });

      promosToClear.forEach((promo) => {
        promo.style.removeProperty('min-height');
        promo.querySelector('.collection-grid-banner__media--promo')?.style.removeProperty('min-height');
      });
    } finally {
      isSyncing = false;
    }
  };

  const scheduleSync = () => {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(() => {
      requestAnimationFrame(syncPromoTileHeights);
    }, 80);
  };

  scheduleSync();
  window.addEventListener('resize', scheduleSync, { passive: true });
  window.addEventListener('load', scheduleSync, { once: true });
  document.fonts?.ready?.then(scheduleSync);
  document.addEventListener('ghalia:products-appended', scheduleSync);

  grid.querySelectorAll('img').forEach((img) => {
    if (img.complete) return;
    img.addEventListener('load', scheduleSync, { once: true });
  });

  if (typeof ResizeObserver !== 'undefined') {
    const observer = new ResizeObserver((entries) => {
      if (isSyncing) return;
      if (!entries.some((entry) => entry.contentRect.height > 0)) return;
      scheduleSync();
    });
    [...grid.children]
      .filter((el) => !el.classList.contains('collection-grid-banner--promo'))
      .forEach((el) => observer.observe(el));
  }

  if (typeof MutationObserver !== 'undefined') {
    const gridObserver = new MutationObserver(() => {
      if (isSyncing) return;
      scheduleSync();
    });
    gridObserver.observe(grid, { childList: true });
  }
})();
